import React from 'react'
import './index.less'
import { useEffect, useState } from 'react'
import { getAuthorOnCard, getAuthorsFirstCharacter } from '@/server'
import { AuthorCard } from '@/components/AuthorCard'
import { Tabs as _Tabs } from 'antd'
import { useAppSelector } from '@/hooks'

const dynastyArr = ['魏晋南北朝', '隋唐', '五代十国', '宋', '元', '明', '清', '近现代']
export function Author() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // 作者展现顺序规则
  const [sortOrder, setSortOrder] = useState<string>('首拼')
  // 当前展现的作者首拼字母
  const [activeChar, setActiveChar] = useState('A')
  // 当前展现的作者朝代
  const [activeDynasty, setActiveDynasty] = useState('魏晋南北朝')
  // 展现作者列表
  const [showList, setShowList] = useState<any[]>([])
  // 作者首拼字母列表（后端维护有画作的作者）
  const [characterArr, setCharacterArr] = useState<any[]>([])
  const typeConfig = { 首拼: 'character', 年代: 'dynasty' }

  // 初始化有作者的首拼字母
  useEffect(() => {
    getAuthorsFirstCharacter(token).then((res) => {
      setCharacterArr(res.data.content)
      setActiveChar(res.data.content[0])
    })
  }, [])
  // 监听选择操作，更新展示列表
  useEffect(() => {
    getAuthorOnCard(
      {
        key: typeConfig[sortOrder],
        value: sortOrder === '首拼' ? activeChar : activeDynasty
      },
      token
    ).then((res) => {
      setShowList(res.data.content)
    })
  }, [sortOrder, activeChar, activeDynasty])

  return (
    <div className='author-container'>
      <div className='sort-select'>
        {Object.keys(typeConfig).map((d) => (
          <div
            className={sortOrder === d ? 'sort-item sort-item-selected' : 'sort-item'}
            onClick={() => setSortOrder(d)}
          >
            {d}
          </div>
        ))}
      </div>
      <div className='sort-keys-container'>
        {(sortOrder === '首拼' ? characterArr : dynastyArr).map((d) => (
          <div
            className={`sort-key-item ${
              d === activeChar || d === activeDynasty ? 'sort-key-item-selected' : ''
            }`}
            onClick={() => {
              if (sortOrder === '首拼') {
                setActiveChar(d)
              } else if (sortOrder === '年代') {
                setActiveDynasty(d)
              }
            }}
          >
            {d}
          </div>
        ))}
      </div>
      <div className='authors-content'>
        {showList.map((d) => (
          <AuthorCard
            name={d.authornamecn}
            count={d.worknum}
            avatar={d.avatarpath}
            id={d.authorid}
          />
        ))}
      </div>
      {/* <Tabs
        activeKey={sortOrder === "首拼" ? activeChar : activeDynasty}
        defaultActiveKey="0"
        tabPosition="top"
        onChange={function (activeKey) {
          if (sortOrder === "首拼") {
            setActiveChar(activeKey)
          } else if (sortOrder === "年代") {
            setActiveDynasty(activeKey)
          }
        }}
        items={(sortOrder === "首拼" ? characterArr : dynastyArr).map((d) => {
          return {
            label: d,
            key: d,
            children: (
              <div className="authors-content">
                {showList.map((d) => (
                  <AuthorCard
                    name={d.authornamecn}
                    count={d.worknum}
                    avatar={d.avatarpath}
                    id={d.authorid}
                  />
                ))}
              </div>
            )
          }
        })}
      /> */}
    </div>
  )
}
